import Store from 'store';

export const SUPPORTED_LANGS = ['kr', 'en', 'ur', 'jp'];
export const DEFAULT_LANG = 'kr';
export const LANG_MAP = {
  // 한국어
  ko: 'kr',
  'ko-kr': 'kr',
  // 일본어
  ja: 'jp',
  'ja-jp': 'jp',
  // 영어
  en: 'en',
  'en-us': 'en',
};

export const API_LANG_MAP = {
  kr: 'KO',
  en: 'EN',
  jp: 'JP',
  uk: 'EN',
}

export const formatToday = () => {
  let now_date = new Date();
  let year = now_date.getFullYear();
  let month = now_date.getMonth() + 1;
  let day = now_date.getDate();

  let t_month = month < 10 ? '0' + month : month;
  let t_day = day < 10 ? '0' + day : day;
  return year + '.' + t_month + '.' + t_day;
};

export function detectBrowserLang(navLang) {
  const raw = (navLang || (typeof navigator !== 'undefined' ? navigator.language : '') || '').toLowerCase();
  if (!raw) return DEFAULT_LANG;

  // 완전 일치 우선
  if (LANG_MAP[raw]) return LANG_MAP[raw];

  // 기본 언어코드(ja-JP → ja)
  const base = raw.split('-')[0];
  if (LANG_MAP[base]) return LANG_MAP[base];

  return DEFAULT_LANG;
}

export function getCurrentLang() {
  try {
    const stored = Store && Store.get && Store.get('lang');
    if (stored && SUPPORTED_LANGS.includes(stored)) return stored;
  } catch (_) {}
  return detectBrowserLang();
}

export function getStringByLang(kr, en, jp) {
  const currentLang = getCurrentLang();

  const langStringMap = {
    kr,
    en,
    jp,
  };

  return langStringMap[currentLang] || en;
}
